import Register from "./components/Register";
import React from "react";
import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import { OutlinedInput} from '@mui/material';
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks"

export const config = {
  endpoint: `https://qkart-backend-y3cr.onrender.com/api/v1`,
};

function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/register" ><Register/></Route>
        <Route exact path="/login" ><Login/></Route>
        <Route exact path="/" ><Products/></Route>
        <Route exact path="/checkout" ><Checkout/></Route>
        <Route exact path="/thanks" ><Thanks/></Route>
      </Switch>
    </div>
  );
}

export default App;
